import { createAction, props } from '@ngrx/store';
import { Country } from 'src/app/shared/models/setups/geography/country.interface';

export const LoadCountries = createAction('[Setups Georaphy] Load Countries');
export const LoadCountriesSuccess = createAction('[Setups Georaphy] Load Countries',
    props<{country: Country[]}>()
);
